// extracted by mini-css-extract-plugin
export var tagsInline = "tags-module--tags-inline--YlDuk";
export var tag = "tags-module--tag--woIvz";